<div class="business-finance-page container-fluid">
  <div class="mat-h2">New Business Term Loan Application</div>
  <application-stepper2 [linear]="false" #applicationStepper="applicationStepper2">
    <cdk-step [stepControl]="formGroupStep1" ><ng-content *ngTemplateOutlet="step1" ></ng-content></cdk-step>
    <cdk-step [stepControl]="formGroupStep2" ><ng-content *ngTemplateOutlet="step2" ></ng-content></cdk-step>
    <cdk-step [stepControl]="formGroupStep3" ><ng-content *ngTemplateOutlet="step3" ></ng-content></cdk-step>
    <cdk-step [stepControl]="formGroupStep4"><ng-content *ngTemplateOutlet="step4Kyb" ></ng-content></cdk-step>
    <cdk-step [stepControl]="formGroupStep5" ><ng-content *ngTemplateOutlet="step5" ></ng-content></cdk-step>
    <cdk-step [stepControl]="formGroupStep6" ><ng-content *ngTemplateOutlet="step6" ></ng-content></cdk-step>
    <cdk-step [stepControl]="formGroupStep7" ><ng-content *ngTemplateOutlet="step7" ></ng-content></cdk-step>
    @if (requiredTrustDeeds.length) {
    <cdk-step [stepControl]="formGroupStep8" ><ng-content *ngTemplateOutlet="step8" ></ng-content></cdk-step>
    }
    <cdk-step [stepControl]="formGroupStep9" ><ng-content *ngTemplateOutlet="step9" ></ng-content></cdk-step>
    <cdk-step [stepControl]="formGroupStep10" ><ng-content *ngTemplateOutlet="step10" ></ng-content></cdk-step>
    <cdk-step [stepControl]="formGroupStep11" ><ng-content *ngTemplateOutlet="step11" ></ng-content></cdk-step>
  </application-stepper2>
</div>


<!--
##########################################
#  STEP 1:
##########################################
-->
<ng-template #step1>
  <div class="step1">
    <form [formGroup]="formGroupStep1" >
      <div class="row">
        <div class="col-lg-6 col-md-12">
          <aggregator-search
            [mandatory]="true"
            [searchFn]="step1BrokerSearchFn"
            [title]="'Introducer'"
            [formControl]="formControlStep1Broker"
            [disabled]="isExternalUser"
          [mark]="applicationStepper.markTriggerSubject(formGroupStep1)"></aggregator-search>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6 col-md-12">
          <salesforce-contact-same-account-selection
            title="Introducer Contact"
            [getFunc]="step1GetSalesforceContactSameAccountFn"
            [salesforceAccountId]="this.step1OrgSalesforceId"
            [formControl]="formControlStep1BrokerContact"
            [mark]="applicationStepper.markTriggerSubject(formGroupStep1)"
            [isMandatory]="true">
          </salesforce-contact-same-account-selection>
        </div>
      </div>
      @if (!step1NoOtherUsersInCompany) {
        <div class="brokerCorrespondent">
          <div class="row mb-4">
            <div class="col-lg-6 col-md-12 showCorrespondent">
              <mat-checkbox color="primary" [formControl]="formControlStep1ShowCorrespondent">Add additional broker correspondent</mat-checkbox>
              <span
                matTooltip="Add in additional broker correspondent"
                matTooltipPosition="after"
              class="tooltip-icon mdi mdi-help-circle-outline ml-1"></span>
            </div>
          </div>
          @if (formControlStep1ShowCorrespondent.value) {
            <div class="row">
              <div class="col-lg-6 col-md-12">
                <user-same-company-selection
                  title="Additional Broker Correspondent"
                  [getFunc]="step1GetUserSameCompanyFn"
                  [salesforceId]="this.step1OrgSalesforceId"
                  [formControl]="formControlStep1Correspondent"
                  [isMandatory]="false">
                </user-same-company-selection>
              </div>
            </div>
          }
        </div>
      }
      <div class="row">
        <div class="col-12">
          <div class="mat-subtitle-1">Applicant's business name</div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6 col-md-12">
          <business-search [placeholder]="businessSearchPlaceholder" [mark]="applicationStepper.markTriggerSubject(formGroupStep1)" [formControl]="formControlStep1Business" [searchFn]="step1BusinessSearchFn"></business-search>
        </div>
      </div>
      @if (formControlStep1Business.value && (formControlStep1Business.value.type === 'search-result') && (step1GstAgeMonths < 12 || formControlStep1PreviousBusiness.value)) {
        <div class="row mb-4">
          <div class="col-lg-6 col-md-12">
            <div class="mb-4">The GST history for the business is less than 12 months. Does the applicant have a prior business with at least 12 months GST history?</div>
            <business-number-search
              [mark]="applicationStepper.markTriggerSubject(formGroupStep1)"
              [searchFn]="step4BusinessNumberSearchFn"
              [formControl]="formControlStep1PreviousBusiness"
            ></business-number-search>
            @if (formControlStep1PreviousBusiness.hasError('previousBusinessSameAsPrimaryEntity')) {
              <message-box type="danger">{{errorMessages(formControlStep1PreviousBusiness, 'previousBusinessSameAsPrimaryEntity')}}</message-box>
            }
          </div>
        </div>
      }
    </form>
  </div>
</ng-template>

<!--
##########################################
#  STEP 2:
##########################################
-->
<ng-template #step2>
  <div class="step2">
    <form [formGroup]="formGroupStep2" >
      <div class="row separator-bottom">
        <div class="col-12">
          <application-header-segment [applicationId]="brokerApplicationId" [titleValue]="organisationName">
          </application-header-segment>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="application-section-title">Business Term Loan application</div>
        </div>
      </div>
      <loan-purpose-selection
        [formControl]="formControlStep2LoanPurpose"
        [mark]="applicationStepper.markTriggerSubject(formGroupStep2)"
        [applicationType]="applicationType"
        >
      </loan-purpose-selection>
      <div class="row">
        <div class="col-lg-3 col-md-12">
          <loan-terms-selection-with-input
            title="Loan term (in months)"
            [mark]="applicationStepper.markTriggerSubject(formGroupStep2)"
            [min]="1"
            [max]="60"
            [formControl]="formControlStep2LoanTerms"
            [businessTermLoans]="true"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-lg-3 col-md-12">
          <brokerage-selection
            [formControl]="formControlStep2Brokerage"
            [max]="BUSINESS_LOAN_MAX_BROKERAGE_PERCENT"
            [mark]="applicationStepper.markTriggerSubject(formGroupStep2)">
          </brokerage-selection>
        </div>
        <div class="col-lg-3 col-md-12">
          <payment-frequency-selection
            [filter]="['Monthly', 'Fortnightly']"
            [formControl]="formControlStep2PaymentFrequency"
            [mark]="applicationStepper.markTriggerSubject(formGroupStep2)">
          </payment-frequency-selection>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-lg-3 col-md-12">
          <yes-no
            title="Property owner"
            [formControl]="formControlStep2PropertyOwner"
            [mark]="applicationStepper.markTriggerSubject(formGroupStep2)">
          </yes-no>
        </div>
        <div class="col-lg-3 col-md-12">
          <yes-no
            title="Adverse on file"
            [formControl]="formControlStep2AdverseOnFile"
            [mark]="applicationStepper.markTriggerSubject(formGroupStep2)">
          </yes-no>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-3 col-md-12">
          <yes-no
            title="Equifax Director Score above 700"
            [formControl]="formControlStep2EquifaxDirectorScoreAbove700"
            [mark]="applicationStepper.markTriggerSubject(formGroupStep2)">
          </yes-no>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-3 col-md-12">
          <yes-no
            title="Doc Fee financed"
            [formControl]="formControlStep2DocFeeFinanced"
            [mark]="applicationStepper.markTriggerSubject(formGroupStep2)">
          </yes-no>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6 col-md-12">
          <currency-input title="Requested limit" [formControl]="formControlStep2LoanAmount" [min]="step2MinLimit" [max]="step2MaxLimit"
          [mark]="applicationStepper.markTriggerSubject(formGroupStep2)"></currency-input>
        </div>
      </div>
    </form>
  </div>
</ng-template>

<!--
##########################################
#  STEP 3:
##########################################
-->
<ng-template #step3>
  <div class="step3">
    <form [formGroup]="formGroupStep3" >
      <div class="row separator-bottom">
        <div class="col-12">
          <application-header-segment [applicationId]="brokerApplicationId" [titleValue]="organisationName">
          </application-header-segment>
        </div>
      </div>
      <div class="row separator">
        <div class="col-12">
          <div class="application-section-title">Organisation details</div>
          <div class="mat-body">Please provide us with further details so we can provide you with a more accurate quote</div>
        </div>
      </div>
      @if (step3AwaitingKyb) {
        <div class="row">
          <div class="col-12">
            <kyb-status
              [applicationId]="applicationId"
              [active]="step3Active"
              [businessName]="organisationName"
              [pollFn]="step3KybResultFn"
              [refreshFn]="step3KybRefreshFn"
              (manualEntry)="onStep3ManualKyb()"
              (resolved)="onStep3KybResolved($event)">
            </kyb-status>
          </div>
        </div>
      } @else {
      <div class="row">
        <div class="col-lg-3 col-md-12">
          <entity-type
            title="Organisation type"
            [readonly]="true"
            [mark]="applicationStepper.markTriggerSubject(formGroupStep3)"
            [formControl]="formControlStep3OrganisationType">
          </entity-type>
        </div>
        <div class="col-lg-3 col-md-12">
          <abn [formControl]="formControlStep3Abn" [mark]="applicationStepper.markTriggerSubject(formGroupStep3)">
          </abn>
        </div>
        @if (step3OnwardsOrganisationType === 'company') {
          <div class="col-lg-3 col-md-12">
            <acn [formControl]="formControlStep3Acn"
              [mark]="applicationStepper.markTriggerSubject(formGroupStep3)">
            </acn>
          </div>
        }
        @if (step3OnwardsOrganisationType === 'trust') {
          <div class="col-lg-3 col-md-12">
            <acn [formControl]="formControlStep3Acn"
              [isMandatory]="false"
              [mark]="applicationStepper.markTriggerSubject(formGroupStep3)">
            </acn>
          </div>
        }
      </div>
      <div class="row">
        <div class="col-lg-3 col-md-12 mt-2">
          <annual-revenue
            title="Annual revenue"
            [mark]="applicationStepper.markTriggerSubject(formGroupStep3)"
            [formControl]="formControlStep3AnnualRevenue" >
          </annual-revenue>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6 col-md-12">
          <primary-industry-selection
            [getIndustryDivisionsFn]="getIndustryDivisionsFn"
            [mark]="applicationStepper.markTriggerSubject(formGroupStep3)"
            [formControl]="formControlStep3PrimaryIndustry">
          </primary-industry-selection>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6 col-md-12">
          <secondary-industry-selection
            [getIndustryGroupsByDivisionCodeFn]="getIndustryGroupsByDivisionCodeFn"
            [divisionCode]="step3PrimaryIndustryDivisionCode"
            [mark]="applicationStepper.markTriggerSubject(formGroupStep3)"
            [formControl]="formControlStep3IndustrySector">
          </secondary-industry-selection>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6 col-md-12">
          <subdivision-industry-selection
            [getIndustryClassesByGroupCodeFn]="getIndustryClassesByGroupCodeFn"
            [groupCode]="step3IndustrySectorGroupCode"
            [mark]="applicationStepper.markTriggerSubject(formGroupStep3)"
            [formControl]="formControlStep3SubdivisionIndustrySector">
          </subdivision-industry-selection>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6 col-md-12">
          <custom-address
            [placesSearchResultFn]="placesSearchResultFn"
            [placesDetailsFn]="placesDetailsFn"
            title="Principal place of business address"
            [mark]="applicationStepper.markTriggerSubject(formGroupStep3)"
            [formControl]="formControlStep3PrimaryBusinessAddress">
          </custom-address>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6 col-md-12">
          <custom-address
            [placesSearchResultFn]="placesSearchResultFn"
            [placesDetailsFn]="placesDetailsFn"
            title="Registered business address"
            [mark]="applicationStepper.markTriggerSubject(formGroupStep3)"
            [formControl]="formControlStep3RegisteredBusinessAddress">
          </custom-address>
        </div>
      </div>
      }
    </form>
  </div>
</ng-template>

<!--
##########################################
#  STEP 4:
##########################################
-->
<ng-template #step4Kyb> <!-- Key People (KYB) -->
  <div class="step4">
    <form [formGroup]="formGroupStep4">
      <div class="row separator-bottom">
        <div class="col-12">
          <application-header-segment [applicationId]="brokerApplicationId" [titleValue]="organisationName">
          </application-header-segment>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <kyb-key-people
            [applicationId]="applicationId ?? 0"
            [uploadedDocuments]="applicationDocuments"
            [active]="step4Active"
            [seedResult]="step3KybResult"
            [kybResultFn]="step4KybResultFn"
            [kybRefreshFn]="step3KybRefreshFn"
            [kybSetManualModeFn]="kybSetManualModeFn"
            [kybInitiateCorporatePartyFn]="step4KybInitiateCorporatePartyFn"
            [businessNumberSearchFn]="step4BusinessNumberSearchFn"
            [organisationType]="step3OnwardsOrganisationType"
            [formControl]="formControlStep4KybKeyPeople"
            (idDocumentDelete)="onIdDocumentDelete(4, $event)"
            (warningsChange)="step4KybWarnings = $event"
            [mark]="applicationStepper.markTriggerSubject(formGroupStep4)">
          </kyb-key-people>
        </div>
      </div>
    </form>
  </div>
</ng-template>

<!--
##########################################
#  STEP 5:
##########################################
-->
<ng-template #step5>
  <div class="step5">
    <div class="row separator-bottom">
      <div class="col-12">
        <application-header-segment [applicationId]="brokerApplicationId" [titleValue]="organisationName">
        </application-header-segment>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <guarantor [businessNumberSearchFn]="step5BusinessNumberSearchFn"
          [formControl]="formControlStep5Guarantors"
          (events)="step5GuarantorEvent($event)"
          [applicationId]="applicationId ?? 0"
          [uploadedDocuments]="applicationDocuments"
          [kybResultFn]="step4KybResultFn"
          [kybRefreshFn]="step3KybRefreshFn"
          [kybSetManualModeFn]="kybSetManualModeFn"
          [kybInitiateCorporatePartyFn]="step4KybInitiateCorporatePartyFn"
          [keyPeopleSelections]="formControlStep4KybKeyPeople.value"
          (idDocumentDelete)="onIdDocumentDelete(5, $event)"
          (kybSelectionsChange)="step5KybSelections = $event"
          (warningsChange)="step5KybWarnings = $event"
          [mark]="applicationStepper.markTriggerSubject(formGroupStep5)"></guarantor>
      </div>
    </div>
  </div>
</ng-template>

<!--
##########################################
#  STEP 6: Individual details review, including the primary contact selection
##########################################
-->
<ng-template #step6>
  <div class="step6">
    <form [formGroup]="formGroupStep6">
      <div class="row separator-bottom">
        <div class="col-12">
          <application-header-segment [applicationId]="brokerApplicationId" [titleValue]="organisationName">
          </application-header-segment>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="application-section-title">Individual Details</div>
        </div>
      </div>

      @if (applicationId) {
        <div class="row separator-bottom">
          <div class="col-12">
            <individual-details-list
              #individualDetailsListComponent
              [applicationId]="applicationId"
              [applicationType]="'BusinessLoans'"
              [idDocumentMetadata]="step9OtherDocMetadata"
              [propertyOwnerRequired]="!!formControlStep2PropertyOwner.value"
              [mark]="applicationStepper.markTriggerSubject(formGroupStep6)"
              [formControl]="formControlStep6IndividualDetails">
            </individual-details-list>
          </div>
        </div>
      }
    </form>
  </div>
</ng-template>

<!--
##########################################
#  STEP 7:
##########################################
-->
<ng-template #step7>
  <div class="step7">
    <div class="row separator-bottom">
      <div class="col-12">
        <application-header-segment [applicationId]="brokerApplicationId" [titleValue]="organisationName">
        </application-header-segment>
      </div>
    </div>
    <form [formGroup]="formGroupStep7">
      <div class="row">
        <div class="col-lg-6 col-md-12">
          <mat-form-field>
            <mat-label>Brokerflow document ID  <span class="mdi mdi-information-outline" matTooltip="If you have already retrieved customer's bank statements using brokerflow, you can provide the ID here and we will not ask the customer to re-provide their bank statements when we assess the application"></span></mat-label>
            <input type="text" matInput [formControl]="formControlStep7BrokerflowDocumentId">
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <reference [formControl]="formControlStep7References"
            [mark]="applicationStepper.markTriggerSubject(formGroupStep7)">
          </reference>
        </div>
      </div>
    </form>
  </div>
</ng-template>

<!--
##########################################
#  STEP 8: trust deeds
##########################################
-->
<ng-template #step8>
  <div class="step8">
    <form [formGroup]="formGroupStep8">
      <div class="row separator-bottom">
        <div class="col-12">
          <application-header-segment [applicationId]="brokerApplicationId" [titleValue]="organisationName">
          </application-header-segment>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="application-section-title">Trust Deed Upload</div>
        </div>
      </div>

      <div class="row separator-bottom">
        <div class="col-lg-6 col-md-12">
          <trust-deed-upload
            [formControl]="formControlStep8TrustDeeds"
            [applicationId]="applicationId ?? null"
            [requiredTrustDeeds]="requiredTrustDeeds"
            [uploadedDocuments]="step9UploadedDocs"
            (deleteUploadedDoc)="onStep8DeleteUploadedDoc($event)"></trust-deed-upload>
        </div>
      </div>
    </form>
  </div>
</ng-template>

<!--
##########################################
#  STEP 9:
##########################################
-->
<ng-template #step9>
  <div class="step9">
    <form [formGroup]="formGroupStep9">
      <div class="row separator-bottom">
        <div class="col-12">
          <application-header-segment [applicationId]="brokerApplicationId" [titleValue]="organisationName">
          </application-header-segment>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="application-section-title">Other supporting documents</div>
        </div>
      </div>

      <div class="row separator-bottom">
        <div class="col-lg-6 col-md-12">
          <uploaded-files-list   [uploadedFiles]="step9UploadedDocs" (events)="onStep9DeleteUploadedDoc($event)"></uploaded-files-list>
        </div>
      </div>

      <div class="row separator-bottom">
        <div class="col-lg-6 col-md-12">
          <upload-files-multi-tags
           #uploadFilesMultiTagsComponent="uploadFilesMultiTagsComponent"
            [allTags]="documentTypes"
            (docEvent)="onStep9DocEvent($event)"
          ></upload-files-multi-tags>
        </div>
      </div>
    </form>
  </div>
</ng-template>

<!--
##########################################
#  STEP 10:
##########################################
-->
<ng-template #step10>
  <div class="step10">
    <form [formGroup]="formGroupStep10">
      <div class="row separator-bottom">
        <div class="col-12">
          <application-header-segment [applicationId]="brokerApplicationId" [titleValue]="organisationName">
          </application-header-segment>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="application-section-title">Overview</div>
          <div class="mat-body mb-3">Detail the applicant's primary operation and reason for the application</div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-6 col-md-12">
          <mat-form-field>
            <mat-label>Application notes</mat-label>
            <textarea matInput rows="10" wrap="hard" maxlength="7000" [formControl]="formControlStep10ApplicationNotes"></textarea>
            @for (errorKey of errorKeys(formControlStep10ApplicationNotes); track errorKey) {
              <mat-error>
                @if (formControlStep10ApplicationNotes.touched && formControlStep10ApplicationNotes.hasError(errorKey)) {
                  {{errorMessages(formControlStep10ApplicationNotes, errorKey)}}
                }
              </mat-error>
            }
          </mat-form-field>
        </div>
      </div>
    </form>
  </div>
</ng-template>

<!--
##########################################
#  STEP 11:
##########################################
-->
<ng-template #step11>
  <div class="step11">
    <div class="row separator-bottom">
      <div class="col-12">
        <application-header-segment [applicationId]="brokerApplicationId" [titleValue]="organisationName">
        </application-header-segment>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <business-finance-summary [summary]="step11Summary"></business-finance-summary>
      </div>
    </div>
  </div>
</ng-template>
